import React, { Component } from "react";
import AgGridTable from "../../../components/common/agGridTable";
import ReadAxios from "../../../components/axiosComponent/read";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../../redux/actions/alertAction";
import { isEmpty } from "lodash";
import { FEATURES, LOCAL_STORAGE } from "../../../utils/constant";
import { aesDecrypt } from "../../../utils/commonFunctionalities";

class Branch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rowData: [],
      loadingData: true,
    };
  }

  componentDidMount() {
    ReadAxios({ completeURL: `${process.env.REACT_APP_MASTER_API}/billing_party` })
      .then(async(dataArray) => {
        if(dataArray?.data?.resultSet?.length){
          for(let data of dataArray.data.resultSet){
            if(data.panNumber) data.panNumber = await aesDecrypt(data.panNumber);
          }
          this.setState({
            rowData: dataArray.data.resultSet,
            loadingData: false,
          });
        }else{
          this.setState({
            rowData: [],
            loadingData: false,
          });
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ loadingData: false, rowData: [] });
      });
  }

  onCellClicked = (rowData) => {
    console.log('check', rowData.data);
    if (this.props.permissions.TA_DRIVER_MASTER.UPDATE == true) {
      typeof rowData.value != 'undefined' && this.onRowEdit(rowData.data);
    }
  }

  onRowEdit = (rowData) => {
    ReadAxios({
      completeURL: `${process.env.REACT_APP_MASTER_API}/billing_party_type_mapping?billingPartyId=${rowData.billingPartyId}`,
    })
      .then((res) => {
        let values = res.data.resultSet
        if(values?.length){
          values.map((el, i) => {
            let temp = {}
            temp.toBeBilled = el.toBeBilled == 1 ? 'toBeBilled' : ''
            temp.toPay = el.toPay == 1 ? 'toPay' : ''
            temp.freeOfCost = el.freeOfCost == 1 ? 'freeOfCost' : ''
            temp.paid = el.paid == 1 ? 'paid' : ''
            rowData.customer_type_id = Object.values(temp)
          })
        }
        this.props.history.push("/add_billing_party", {
          ...rowData,
          title: "edit_title",
        });
      })
      .catch((err) => {
        console.log(err);
      });

  };

  onRowDelete = (alert) => {
    if (alert.type === "success") this.props.successAlert(alert);
    else this.props.errorAlert(alert);
    this.props.history.push("/billingParty");
    this.props.history.go();
  };

  exporDatatFunction = async(data, cancelExportLoading) => {
    window.location.href= `${process.env.REACT_APP_MASTER_API}/billingParty/export?customerNumber=${LOCAL_STORAGE.customerNo}&userId=${LOCAL_STORAGE.userId}&authorization=${LOCAL_STORAGE.userToken}`
    cancelExportLoading()
  }

  render() {
    const { rowData } = this.state;
    const { t } = this.props;
    const Columns = [
      {
        headerName: t("billingPartyName.title") || "Branch Name",
        field: "billingPartyName",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("billingPartyCode.title") || "Code",
        field: "billingPartyCode",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("industry.title") || "City",
        field: "industrySegmentName",
        sortable: true,
        filter: true,
      },
      // {
      //   headerName: t("table_header.mobile_number") || "Mobile Number",
      //   field: "cityName",
      //   sortable: true,
      //   filter: true,
      //   hide: true,
      // },
      // {
      //   headerName: t("table_header.sim_card_provider") || "Sim Card Provider",
      //   field: "address",
      //   sortable: true,
      //   filter: true,
      //   hide: true,
      // },
      {
        headerName: t("createdBy") || "Created By",
        field: "createdByName",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("createdOn") || "Created On",
        field: "createdOn",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("modifiedBy") || "Modified By",
        field: "updatedByName",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("modifiedOn") || "Modified On",
        field: "updatedOn",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("action_button.edit_delete") || "Edit / Delete",
        field: "edit",
        cellRenderer: "actionRenderer",
        suppressToolPanel: true,
        pinned: "right",
        hide: !this.props.permissions.TA_DRIVER_MASTER.UPDATE && !this.props.permissions.TA_DRIVER_MASTER.DELETE,
      },
    ];
    return (
      <React.Fragment>
        <AgGridTable
          isLoading={this.state.loadingData}
          columnDefs={Columns}
          rowData={rowData}
          titleBarTitle={this.props.t("title") || "Billing Party"}
          titleBarLink={"/add_billing_party"}
          baseURL={"billingPartyMaster"}
          pathName={"billingPartyMaster"}
          completeURL={`${process.env.REACT_APP_MASTER_API}/billing_party`}
          keyIndex={"billingPartyId"}
          onEdit={this.onRowEdit}
          cellDoubleClicked={this.onCellClicked}
          onDelete={this.onRowDelete}
          hideRowEdit={!this.props.permissions.TA_DRIVER_MASTER.UPDATE}
          hideRowDelete={!this.props.permissions.TA_DRIVER_MASTER.DELETE}
          exportHidden={FEATURES.mastersExportDisabled()}
          suppressExcelExport={FEATURES.mastersExportDisabled()}
          suppressCsvExport={FEATURES.mastersExportDisabled()}
          exporDatatFunction = {this.exporDatatFunction}
        />
      </React.Fragment>
    );
  }
}
const mapStateToProps = ({ permissions }) => {
  return {
    permissions,
  }
};
const mapDispatchToProps = (dispatch) => {
  return {
    successAlert: (alert) => dispatch(successAlertDispatcher(alert)),
    errorAlert: (alert) => dispatch(errorAlertDispatcher(alert)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(translate("create_billing_party")(Branch));
